export default "/build/images/logo-arabic-768x224.png?964f3c84b43f9dc78ef315e7243c171e";